import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseRepository } from '../../Common/Data/base.repository';
import { Observable } from 'rxjs';

@Injectable()
export class DataHubLogRepository extends BaseRepository {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    getList(searchModel: Core.DataHubSummaryLogSearchModel): Observable<Compliance.QueryResultModel<Core.DataHubSummaryLogModel>> {
        return this.httpPost('/api/diagnostics/dataHub/summary', searchModel);
    }

    getDetail(searchModel: Core.DataHubDiagnosticsDetailSearchModel): Observable<Core.DataHubDiagnosticsDetailModel> {
        return this.httpPost(`/api/diagnostics/dataHub/detail`, searchModel);
    }
}
